// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"95":"0e1e9d0a","112":"09b4aa1f","349":"afb268e0"}[chunkId] + ".chunk.css";
};